import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright © 2025-2026 Cognizant Digital Business, Evolutionary AI.
 * All Rights Reserved.
 * Issued under the Academic Public License.
 *
 * You can be released from the terms, and requirements of the Academic Public
 * License by purchasing a commercial license.
 * Purchase of a commercial license is mandatory for any use of the
 * LMX Software in commercial settings.
 */
// END COPYRIGHT
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
const StyledHelpButton = styled(IconButton)(({ theme }) => ({
    marginLeft: 8,
    color: theme.palette.text.secondary,
    padding: 6,
    "&:hover": {
        backgroundColor: theme.palette.action.hover,
    },
}));
export const HelpIcon = (props) => (_jsx(StyledHelpButton, { ...props, children: _jsx("span", { "aria-hidden": "true", style: {
            display: "inline-block",
            width: 18,
            height: 18,
            lineHeight: "16px",
            textAlign: "center",
            borderRadius: "50%",
            border: "1px solid currentColor",
            fontSize: 12,
            fontWeight: 700,
        }, children: "?" }) }));
